import { StyledContainer } from './styled-components'
import useTabBar from '@/containers/SubscriptionFormPageNew/SubscriptionForm/useTabBar'
import ModuleToggle from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleToggle'
import ModuleHeading from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleHeading'
import IconCarbonToolKit from '@/shared/icons/IconCarbonToolKit'
import useModuleCollapse from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/useModuleCollapse'
import {
  ModuleBody,
  ModuleContent,
} from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/styled-components'
import ModuleHeader from '@/containers/SubscriptionFormPageNew/Components/shared/ModuleCollapse/ModuleHeader'
import { TileGrid } from '@/containers/SubscriptionFormPageNew/Components/shared/ActionTile/styled-components'
import ExportLogs from './ExportLogs/ExportLogs'
import HistoricAuditLogs from './HistoricAuditLogs/HistoricAuditLogs'
import ChangeUser from './ChangeUser/ChangeUser'
import ZohoButton from './ZohoButton/ZohoButton'
import AbandonContract from './AbandonContract/AbandonContract'
import Comments from './Comments/Comments'
const Tools = () => {
  const { t } = useTabBar()
  const { expanded, toggle } = useModuleCollapse('tools')

  return (
    <StyledContainer>
      <ModuleHeader clickable onClick={toggle}>
        <ModuleHeading icon={IconCarbonToolKit} moduleKey='tools'>
          {t('subscriptionTools:tools.module_title')}
        </ModuleHeading>
        <ModuleToggle expanded={expanded} onToggle={toggle} moduleKey='tools' />
      </ModuleHeader>
      <ModuleContent hidden={!expanded}>
        <ModuleBody>
          <TileGrid>
            <ZohoButton />
            <ExportLogs />
            <HistoricAuditLogs />
            <ChangeUser />
            <AbandonContract />
            <Comments />
          </TileGrid>
        </ModuleBody>
      </ModuleContent>
    </StyledContainer>
  )
}

export default Tools
